export enum PickRoundSpotStatus {
    /**
     * Spot cannot be selected/revealed by player.
     */
    Disabled = <any>'disabled',

    /**
     * Spot can be selected/revealed by player.
     */
    Enabled = <any>'enabled',

    /**
     * Spot was selected by player (but not revealed yet).
     */
    Selected = <any>'selected',

    /**
     * Spot was revealed by player.
     */
    Revealed = <any>'revealed',

    /**
     * Spot value is shown to player.
     */
    Shown = <any>'shown'
}


/** WEBPACK FOOTER **
 ** ./Engine/Communication/Game/Types/PickRoundSpotStatus.ts
 **/